<template>
    <v-container fluid>
        <v-layout row wrap>
        <v-flex xs12>
            <v-container fluid>
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-badge v-model="badge" color="red">
                            <v-chip 
                            label disabled
                            small slot="badge"
                            color="red"
                            text-color="white"
                            >Скрыто
                            </v-chip>
                            <span class="headline">{{ editClinic.name }}</span>
                        </v-badge>
                        <div class="caption grey--text">Обновлено: {{ lastModified }}</div>
                    </v-flex>
                </v-layout>
            </v-container>
            <v-container fluid>
                <v-layout row wrap>
                    <v-flex xs6>
                        <v-switch color="primary"
                            label="Отображается на сайте"
                            v-model="editClinic.isActive"
                            hide-details
                            @change="setIsPublish"
                        ></v-switch>
                        <v-switch color="primary"
                            disabled
                            label="Доступно для записи к врачу"
                            v-model="editClinic.isAppointment"
                            hide-details
                        ></v-switch>
                    </v-flex>
                </v-layout>
            </v-container>

            <v-container fluid>
                <v-layout row wrap>
                    <v-flex xs12>
                        <div class="title">Данные для сайта</div>
                    </v-flex>
                </v-layout>
            </v-container>

            <v-container fluid>
                <v-layout row>
                    <v-flex xs5>
                        <v-layout row wrap>
                            <v-flex xs12>

                               <v-text-field
                                label="Название для сайта"
                                v-model="editClinic.name"
                                required
                                ></v-text-field>

                                <v-select
                                v-model="editClinic.clinicTypes"
                                label="Тип ЛПУ"
                                multiple
                                :items="GET_ALL_CLINIC_TYPES"
                                required
                                ></v-select>
                                
                                <v-select
                                v-model="editClinic.region.id"
                                item-text="name"
                                item-value="id"
                                label="Регион"
                                @change="updateAllDistrictsInRegion"
                                :items="allRegions"
                                ></v-select>

                                <v-select
                                v-model="editClinic.district"
                                label="Район"
                                :items="allDistricts"
                                ></v-select>

                                <v-text-field
                                label="Адрес"
                                v-model="editClinic.address"
                                required
                                ></v-text-field>

                                <v-text-field
                                label="Сайт"
                                v-model="editClinic.siteUrl"
                                required
                                ></v-text-field>

                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs5 offset-xs1>
                        <v-layout row wrap>
                            <v-flex xs12>

                                <v-text-field
                                label="Телефон"
                                v-model="editClinic.phone"
                                required
                                ></v-text-field>

                                <v-text-field
                                label="E-Mail"
                                v-model="editClinic.email"
                                required
                                ></v-text-field>
                                
                                <v-text-field
                                label="Режим работы"
                                v-model="editClinic.worktime"
                                required
                                ></v-text-field>

                                <v-text-field
                                name="input-7-1"
                                label="Описание ЛПУ для сайта"
                                auto-grow
                                v-model="editClinic.description"
                                multi-line
                                required
                                ></v-text-field>

                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-btn class="primary" @click.prevent="saveMainDataChanges">
                            Сохранить
                        </v-btn>
                        <v-btn @click="breakChangesInMainInfo">
                            Сбросить
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-container>

            <v-container fluid>
                <v-layout row wrap>
                    <v-flex xs12>
                        <div class="title">Данные из ЕИС ОМС</div>
                    </v-flex>
                </v-layout>
            </v-container>

            <v-container fluid>
                <v-layout row>
                    <v-flex xs5>
                        <v-layout row wrap>
                            <v-flex xs12>

                               <v-text-field
                                label="Идентификатор в ОМС"
                                v-model="omsId"
                                ></v-text-field>

                               <v-text-field
                                label="Название в ОМС"
                                :value="omsName"
                                disabled
                                ></v-text-field>
                                
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs5 offset-xs1>
                        <v-layout row wrap>
                            <v-flex xs12>

                                <v-text-field
                                label="Тип в ОМС"
                                :value="omsType"
                                disabled
                                ></v-text-field>

                                <v-text-field
                                label="Реестровый номер"
                                :value="omsRegistry"
                                disabled
                                ></v-text-field>

                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-btn class="primary" @click.prevent="saveOMSDataChanges">
                            Сохранить
                        </v-btn>
                        <v-btn @click="breakChangesInOMS">
                            Сбросить
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-container>

            <v-container fluid>
                <v-layout row wrap>
                    <v-flex xs12>
                        <div class="title">Данные из Нетрики</div>
                    </v-flex>
                </v-layout>
            </v-container>


            <v-container fluid>
                <v-layout row>
                    <v-flex xs5>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <v-text-field
                                label="Идентификатор в Нетрике"
                                v-model="netrikaID"
                                ></v-text-field>

                                <v-text-field
                                label="Универсальный идентификатор объекта"
                                :value="netrikaOid"
                                disabled
                                ></v-text-field>

                                <v-text-field
                                label="Короткое название в Нетрике"
                                :value="netrikaShortName"
                                disabled
                                ></v-text-field>

                                <v-text-field
                                label="Полное название в Нетрике"
                                :value="netrikaFullNames.join(';')"
                                multi-line
                                disabled
                                ></v-text-field>

                                <v-text-field
                                :value="netrikaTypes.join('; ')"
                                label="Типы в Нетрике"
                                disabled
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs5 offset-xs1>
                        <v-layout row wrap>
                            <v-flex xs12>
                                                             
                                <v-text-field
                                label="Район в Нетрике"
                                :value="netrikaDistrict"
                                disabled
                                ></v-text-field>

                                <v-text-field
                                label="Адрес в Нетрике"
                                :value="netrikaAddress"
                                disabled
                                ></v-text-field>

                                <v-text-field
                                label="Телефон в Нетрике"
                                :value="netrikaPhone"
                                disabled
                                ></v-text-field>

                                <v-text-field
                                label="E-mail в Нетрике"
                                :value="netrikaEmail"
                                disabled
                                ></v-text-field>

                                <v-text-field
                                label="Режим работы в Нетрике"
                                :value="netrikaWorkTime"
                                disabled
                                ></v-text-field>
                               
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-btn class="primary" @click.prevent="saveNetrikaDataChanges">
                            Сохранить
                        </v-btn>
                        <v-btn @click="breakChangesInNetrika">
                            Сбросить
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-container>

            <v-container fluid>
                <v-layout row wrap>
                    <v-flex xs12>
                        <div class="title">SEO настройки</div>
                    </v-flex>
                </v-layout>
            </v-container>
            <v-container fluid>
                <v-layout row wrap>
                    <v-flex xs5>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <v-text-field
                                label="Meta Title"
                                v-model="editMeta.title"
                                counter="75"
                                ></v-text-field>

                                <v-text-field
                                label="H1 для страницы"
                                v-model="editMeta.heading"
                                counter="90"
                                ></v-text-field>

                                <v-text-field
                                label="ЧПУ"
                                v-model="editMeta.slug"
                                counter="90"
                                ></v-text-field>

                                <v-text-field
                                label="Мета описание"
                                v-model="editMeta.description"
                                counter="160"
                                multi-line
                                ></v-text-field>

                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
                <v-layout row wrap>
                    <v-flex xs12>
                        <v-btn class="primary" @click.prevent="saveMetaDataChanges">
                            Сохранить
                        </v-btn>
                        <v-btn @click="breakChangesInMeta">
                            Сбросить
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-flex>
    </v-layout>
    <v-snackbar
      :timeout="5000"
      :color="snackbar.color"
      :multi-line="'multi-line'"
      v-model="snackbar.status"
    >
      {{ snackbar.text }}
      <v-btn dark flat @click.native="snackbar.status = false">Закрыть</v-btn>
    </v-snackbar>
    </v-container>
</template>
<script>
import { mapGetters, mapActions } from 'vuex' 
import { isEqual } from 'lodash'

export default {
    props: {
        clinic: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            snackbar: {
                status: false,
                color: '',
                text: ''
            },

            
            // Раздел "Для сайта"
            editClinic: {
                isActive: this.clinic.isActive,
                isAppointment: this.clinic.isAppointment,
                name: this.clinic.name,
                region: {
                    id: this.clinic.region.id,
                    name: this.clinic.region.name
                },
                clinicTypes: this.clinic.clinicTypes,
                description: this.clinic.description,
                district: this.clinic.district,
                address: this.clinic.address,
                phone: this.clinic.phone,
                email: this.clinic.email,
                siteUrl: this.clinic.siteUrl,
                worktime: this.clinic.worktime,
            },

            // Regions
            editRegionName: this.clinic.region.name || 'Не выбрано',
            editRegionId: this.clinic.region.id || null,

            // Раздел "Данные из ЕИС ОМС"
            omsId: this.clinic.oms.id,
            omsName: this.clinic.oms.name|| 'Отсутствует',
            omsType: this.clinic.oms.type|| 'Отсутствует',
            omsRegistry: this.clinic.oms.registry|| 'Отсутствует',

            // Раздел "Данные из Нетрики"
            netrikaID: this.clinic.netrika.id,
            netrikaOid: this.clinic.netrika.oid || 'Отсутствует',
            netrikaShortName: this.clinic.netrika.shortName || 'Отсутствует',
            netrikaFullNames: (this.clinic.netrika.fullNames.length > 0) ? this.clinic.netrika.fullNames : ['Отсутствует'],
            netrikaEmail: this.clinic.netrika.email || 'Отсутствует',
            netrikaPhone: this.clinic.netrika.phone || 'Отсутствует',
            netrikaTypes: this.clinic.netrika.types || ['Отсутствует'],
            netrikaWorkTime: this.clinic.netrika.worktime || 'Отсутствует',
            netrikaAddress: this.clinic.netrika.address || 'Отсутствует',
            netrikaDistrict: this.clinic.netrika.district || 'Отсутствует',

            // Раздел "СЕО Настройки"
            editMeta: {
                title: this.clinic.meta.title,
                heading: this.clinic.meta.heading,
                slug: this.clinic.meta.slug,
                description: this.clinic.meta.description
            }
        }
    },
    methods: {
        ...mapActions([
            'SET_IS_PUBLISH',
            'LOAD_DISTRICS_IN_REGION',
            'LOAD_CLINIC_TYPES',
            'LOAD_REGIONS',
            'CLEAR_DISTRICS_STATE'
        ]),

        snackbarOpen(color, msg) {
            this.snackbar.status = true,
            this.snackbar.color = color
            this.snackbar.text = msg
        },

        updateAllDistrictsInRegion() {
            setTimeout( () => {
                this.LOAD_DISTRICS_IN_REGION(this.editClinic.region.id)
            }, 10)
        },

        waittoRegionIDUpdate() {
            return new Promise((resolve, reject) => {
                setTimeout( () => {
                    if (this.editClinic.region.id) resolve(this.editClinic.region.id)
                    else reject('undefined')
                }, 10)
            })
        },

		breakChangesInMainInfo() {
            for (let prop in this.editClinic) {
                this.editClinic[prop] = this.clinic[prop]
            }
        },
        
        breakChangesInOMS() {
            this.omsId = this.clinic.oms.id
        },

        breakChangesInNetrika() {
            this.netrikaID = this.clinic.netrika.id
        },

		breakChangesInMeta() {
			this.editMeta.title = this.clinic.meta.title
            this.editMeta.heading = this.clinic.meta.heading
            this.editMeta.slug = this.clinic.meta.slug
            this.editMeta.description = this.clinic.meta.description
		},

        setIsPublish() {
            this.SET_IS_PUBLISH({ id: this.clinic.id, isActive: this.editClinic.isActive})
                .then( msg => {
                    this.snackbarOpen('success', msg)
                })
                .catch( e => {
                    this.snackbarOpen('error', e.message)
                })
        },

        saveMainDataChanges() {
            const payload = {
                id: this.clinic.id,
                clinic: {}
            }

            for (let prop in this.editClinic) {
                if (!isEqual(this.editClinic[prop], this.clinic[prop]))
                    payload.clinic[prop] = this.editClinic[prop]
            }
                        
            if (Object.keys(payload.clinic).length !== 0) {
                                
                this.$store.dispatch('SAVE_MAIN_DATA_CHANGES', payload)
                    .then( msg => {
                        this.snackbarOpen('success', msg)
                    })
                    .catch( e => {
                        this.snackbarOpen('error', e.message)
                    })
            } else this.snackbarOpen('error', 'Данные не были изменены')
        },

        saveOMSDataChanges() {
            const payload = {
                id: this.clinic.id,
                clinic: {
                    oms: {}
                }
            }

            if (this.omsId !== this.clinic.oms.id) 
                payload.clinic.oms.id = this.omsId
            
            if (Object.keys(payload.clinic.oms).length !== 0) {
                this.$store.dispatch('SAVE_OMS_ID', payload)
                    .then( msg => {
                        this.snackbarOpen('success', msg)
                    })
                    .catch( e => {
                        this.snackbarOpen('error', e.message)
                    })
            } else 
                this.snackbarOpen('error', 'Данные не были изменены')
        },

        saveNetrikaDataChanges() {
            const payload = {
                id: this.clinic.id,
                clinic: {
                    netrika: {}
                }
            }
                        
            if (this.netrikaID !== this.clinic.netrika.id) 
                payload.clinic.netrika.id = this.netrikaID
            
            if (Object.keys(payload.clinic.netrika).length !== 0) {                
                this.$store.dispatch('SAVE_OMS_ID', payload)
                    .then( msg => {
                        this.snackbarOpen('success', msg)
                    })
                    .catch( e => {
                        this.snackbarOpen('error', e.message)
                    })
            } else 
                this.snackbarOpen('error', 'Данные не были изменены')
        },

        saveMetaDataChanges() {
            const payload = {
                id: this.clinic.id,
                meta: {}
            }
            
            for (let prop in this.editMeta) {
                if (!isEqual(this.editMeta[prop], this.clinic.meta[prop]))
                    payload.meta[prop] = this.editMeta[prop]
            }                

            if (Object.keys(payload.meta).length !== 0) {
                this.$store.dispatch('SAVE_META_DATA_CHANGES', payload)
                    .then( msg => {
                        this.snackbarOpen('success', msg)
                    })
                    .catch( e => {
                        this.snackbarOpen('error', e.message)
                    })
            } else this.snackbarOpen('error', 'Данные не были изменены')           
        }
    },

    computed: {
        ...mapGetters([
            'GET_ALL_CLINIC_TYPES',
            'GET_ALL_REGIONS',
            'GET_ALL_DISTRICTS_IN_REGION',
            'GET_REGION_ID'
        ]),

        lastModified() {
            return `${new Date(this.clinic.lastModified)}`
        },

        allRegions() {
            return this.GET_ALL_REGIONS
        },

        allDistricts() {
            return this.GET_ALL_DISTRICTS_IN_REGION
        },

        badge() {
            return this.editClinic.isActive ? false : true
        }
    },

    watch: {

    },

    created() {
        this.LOAD_CLINIC_TYPES()
        this.LOAD_REGIONS()
        if(this.clinic.region.id)
            this.LOAD_DISTRICS_IN_REGION(this.clinic.region.id)
        else 
            this.CLEAR_DISTRICS_STATE()
    }
}
</script>



            

            
            
